export const TEPMLATE_TABS = [
  {
    label: "Job Templates",
    value: 1,
  },
  {
    label: "Email Templates",
    value: 0,
  },
  {
    label: "Offers Template",
    value: "OFFER",
  },
  {
    label: "Salary Breakup Template",
    value: "SALARY",
  },
];

export const TEPLATES_TAB_MAPPER = {
  SALARY: "SALARY",
  OFFER: "OFFER",
  JOB: 1,
  EMAIL: 0,
};

export const DEFAULT_SALARY_TEMPLATE_IN = [
  {
    section: "Earnings",
    items: [
      {
        name: "Basic Salary",
        type: "basic",
        value: 50,
        is_selected: true,
        is_monthly: true,
      },
      {
        name: "House Rent Allowance",
        type: "fromBasic",
        value: 50,
        is_selected: true,
        is_monthly: true,
      },
      {
        name: "Leave Travel Allowance",
        type: "fixed",
        value: 0,
        is_selected: false,
        is_monthly: false,
      },
      {
        name: "Conveyance Allowance",
        type: "fixed",
        value: 0,
        is_selected: false,
        is_monthly: true,
      },
      {
        name: "Special Allowance",
        type: "special",
        value: 0,
        is_selected: true,
        is_monthly: true,
      },
    ],
  },
  {
    section: "Retirement Benefits",
    items: [

      {
        name: "Provident Fund",
        type: "fixed",
        value: 0,
        is_selected: false,
        is_monthly: true,
      },
      {
        name: "Gratuity",
        type: "fixed",
        value: 0,
        is_selected: false,
        is_monthly: true,
      },
    ],
  },
  {
    section: "Other Benefits",
    items: [{
      name: "Performance Bonus",
      type: "fixed",
      value: 100000,
      is_selected: false,
      is_monthly: false,
    },
    {
      name: "Medical Insurance",
      type: "fixed",
      value: 3200,
      is_selected: false,
      is_monthly: true,
    },
    {
      name: "Life Insurance",
      type: "fixed",
      value: 1600,
      is_selected: false,
      is_monthly: true,
    },
    ],
  },
];

export const DEFAULT_SALARY_TEMPLATE_GB = [
  {
    section: "Earnings",
    items: [
      {
        name: "Basic Salary",
        type: "basic",
        value: 50,
        is_selected: true,
        is_monthly: true,
      },
    ],
  },
  {
    section: "Retirement Benefits",
    items: [
      {
        name: "Pension Contribution",
        type: "fixed",
        value: 0,
        is_selected: false,
        is_monthly: true,
      },
    ],
  },
  {
    section: "Other Benefits",
    items: [{
      name: "Performance Bonus",
      type: "fixed",
      value: 100000,
      is_selected: false,
      is_monthly: false,
    },
    {
      name: "Medical Insurance",
      type: "fixed",
      value: 3200,
      is_selected: false,
      is_monthly: true,
    },
    {
      name: "Life Insurance",
      type: "fixed",
      value: 1600,
      is_selected: false,
      is_monthly: true,
    },
    ],
  },
];

export const SALARY_TEMP_SHORT_TYPES_MAPPER = {
  basic: "Basic",
  fromBasic: "% of Basic",
  special: "Balancing Amount",
  fixed: "Fixed",
  percentage: "Percentage",
  sb: "Statutory Bonus"
};
